import React from "react";

const ComponentThemesContribution = (props) => {
  const { contribution } = props;

  const afficheThemes = () => {
    return (
      <div className=" mt-2 mb-2">
        {contribution.themes &&
          contribution.themes.map((item, index) => (
            <span className="etiquette" key={index}>
              {item}
            </span>
          ))}
      </div>
    );
  };
  return <>{afficheThemes()}</>;
};

export default ComponentThemesContribution;
